import CardModuleApi from '@/featureModules/cardModule/service'
import { useCardModuleStore } from '@/featureModules/cardModule/store'

export default {
  store: useCardModuleStore,
  service: new CardModuleApi(),
}
